import {
  GET_PATHS,
  GET_PATHS_LIST,
  GET_PATHS_MINIMAL,
  GET_PATH,
  ADD_PATH,
  DELETE_PATH,
  UPDATE_PATH,
  PATHS_LOADING,
  SET_PATHS_PAGE,
  CLEAR_CURRENT_PATH
} from '../actions/types';

const initialState = {
  paths: [],              // Full paths (for backward compatibility)
  pathsList: [],          // Paginated list for table
  minimalPaths: [],       // Minimal list for filters
  currentPath: null,      // Single path for editor
  loading: false,
  currentPage: 1,
  totalPages: 0,
  totalPaths: 0,
  hasNextPage: false,
  hasPrevPage: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PATHS:
      return { ...state, paths: action.payload, loading: false };

    case GET_PATHS_LIST:
      return {
        ...state,
        pathsList: action.payload.paths || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalPaths: action.payload.totalPaths || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };

    case GET_PATHS_MINIMAL:
      return {
        ...state,
        minimalPaths: action.payload,
        loading: false
      };

    case GET_PATH:
      return {
        ...state,
        currentPath: action.payload,
        loading: false
      };

    case SET_PATHS_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };

    case CLEAR_CURRENT_PATH:
      return {
        ...state,
        currentPath: null
      };

    case ADD_PATH:
      return {
        ...state,
        paths: [action.payload, ...state.paths],
        pathsList: [action.payload, ...state.pathsList]
      };

    case UPDATE_PATH:
      return {
        ...state,
        paths: state.paths.map(path =>
          path._id === action.payload._id ? action.payload : path
        ),
        pathsList: state.pathsList.map(path =>
          path._id === action.payload._id ? action.payload : path
        ),
        currentPath: state.currentPath?._id === action.payload._id
          ? action.payload
          : state.currentPath
      };

    case DELETE_PATH:
      return {
        ...state,
        paths: state.paths.filter(path => path._id !== action.payload),
        pathsList: state.pathsList.filter(path => path._id !== action.payload)
      };

    case PATHS_LOADING:
      return { ...state, loading: true };

    default:
      return state;
  }
}
